import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";

const FIELDS = [
  ["company_name", "Company name"],
  ["cage_code", "CAGE code"],
  ["employee_count", "Employee count"],
  ["cloud_stack", "Cloud / IT stack"],
  ["handles_cui", "Handles CUI? (Yes/No)"],
  ["security_lead", "Security lead / role owner"],
];

export default function Settings() {
  const [org, setOrg] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/org").then((r) => setOrg(r.data)); }, []);

  const save = async () => {
    setSaving(true);
    try {
      const payload = Object.fromEntries(FIELDS.map(([k]) => [k, org[k] || ""]));
      const { data } = await api.put("/org", payload);
      setOrg(data);
      toast.success("Organization profile saved. New policies will use these details.");
    } catch (e) { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  if (!org) return <div className="p-10 flex items-center gap-2 text-slate-500"><Loader2 className="h-5 w-5 animate-spin" /> Loading…</div>;

  return (
    <div className="p-8 max-w-2xl">
      <div className="mb-6">
        <div className="overline mb-1">Configuration</div>
        <h1 className="font-display font-bold text-3xl tracking-tight">Organization Profile</h1>
        <p className="text-slate-500 text-sm mt-1">Drives policy customization and your cold-outreach hook (CAGE code).</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-md p-6 shadow-sm space-y-4">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <label className="text-sm font-medium text-slate-700">{label}</label>
            <input value={org[k] || ""} onChange={(e) => setOrg({ ...org, [k]: e.target.value })} data-testid={`org-${k}`}
              className="w-full mt-1 px-3 py-2 border border-slate-300 rounded-md focus:ring-2 focus:ring-brand-accent focus:outline-none" />
          </div>
        ))}
        <button onClick={save} disabled={saving} data-testid="save-org-btn"
          className="bg-brand text-white px-5 py-2.5 rounded-md text-sm font-medium flex items-center gap-2 hover:bg-brand-secondary transition-colors disabled:opacity-50">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save profile
        </button>
      </div>
    </div>
  );
}
